<div  class="flex flex-col max-w-200 md:min-w-160 max-h-200 -m-6" >

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">
            <fa-icon [icon]="faTicket" class="mr-2"></fa-icon>
            Support
        </div>
        <button
            mat-icon-button
            (click)="matDialogRef.close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <!-- Compose form -->
    <form
        class="flex flex-col flex-auto p-6 sm:p-8"
        [formGroup]="supportForm">

        <mat-form-field *ngIf="false">
                        
            <input matInput formControlName="id" [placeholder]="'Id'" hidden>

        </mat-form-field>
       
        

          <div class="flex flex-col flex-auto">
            <div class="grid grid-cols-2 xl:grid-cols-2 gap-4 w-full">
                
                <div class="flex flex-col flex-auto">
                    <mat-form-field>
                        <mat-label>Category</mat-label>
                        <mat-select [formControl]="supportForm.get('category')" >
                            <mat-option [value]="0">Berth Window</mat-option>
                            <mat-option [value]="1">LineUp DateTime</mat-option>
                            <mat-option [value]="2">Service or Vessel Name</mat-option>
                            <mat-option [value]="3">Others</mat-option>
                        </mat-select>
                    </mat-form-field>
                    
                </div>

                <div class="flex flex-col flex-auto">
                    <mat-form-field>
                        <mat-label>Severity</mat-label>
                        <mat-select [formControl]="supportForm.get('severity')" >
                            <mat-option [value]="0">Low</mat-option>
                            <mat-option [value]="1">Medium</mat-option>
                            <mat-option [value]="2">High</mat-option>
                            <mat-option [value]="3">Critical</mat-option>
                        </mat-select>
                    </mat-form-field>
                    
                </div>
                
            </div>
            <div class="grid grid-cols-1 xl:grid-cols-1 gap-4 w-full">
                <div class="flex flex-col flex-auto">
                    <mat-form-field
                            class="flex-auto">
                            <mat-label>Description</mat-label>
                            <textarea matInput rows="2"  [formControl]="supportForm.get('description')"></textarea>
                            <mat-hint>Include key information such as the vessel name, voyage number, and reference number.</mat-hint>
                        </mat-form-field>
            
                </div>
            </div>
            

        </div>

          


        <!-- Actions -->
        <div class="flex items-center justify-end  -mx-8 mt-4 px-8 py-5">
            <button mat-button (click)="matDialogRef.close()">
                Cancel
            </button>
            <button
                class="px-6 ml-3"
                mat-flat-button
                [color]="'primary'"
                (click)="onSend()">
                Send
            </button>
        </div>
    </form>
</div>
